import { SnackbarProvider } from 'notistack';
import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Routes, Route } from 'react-router-dom';

import { Loader } from '../base/components/Loader';
import { SnackbarManager } from '../base/components/SnackBar';
import { Loading } from '../base/enums';
import { useAppDispatch, useAppSelector, useRoutesWithLang } from '../base/hooks';
import { recruiterAppActions } from './redux/slices/recruiterAppSlice';

import { Login } from './units/authorization/pages/Login';
import { PasswordRecoveryPage } from './units/authorization/pages/PasswordRecovery';
import { SignUpPage } from './units/authorization/pages/SignUp';
import { Settings } from './units/settings/pages/Settings';
import { ChangeLoginPage } from './units/settings/pages/ChangeLogin';
import { PasswordChangePage } from './units/settings/pages/ChangePassword';
import { Profile } from './units/settings/pages/Profile';
import { SettingsRoutes } from './units/settings/routes';
import { AuthRoutes } from './units/authorization/routes';

export const RecruiterApp = () => {
    const {
        app: { loading },
        recruiterApp: { initialized },
    } = useAppSelector((state) => state);
    const dispatch = useAppDispatch();
    const authRoutes = useRoutesWithLang<typeof AuthRoutes>(AuthRoutes);
    const settingsRoutes = useRoutesWithLang<typeof SettingsRoutes>(SettingsRoutes);

    useEffect(() => {
        dispatch(recruiterAppActions.init());
    }, []);

    if (!initialized) {
        return (
            <div className='recruiter-app'>
                <Loader showLoader={loading === Loading.App} />
            </div>
        );
    }

    return (
        <HelmetProvider>
            <SnackbarProvider maxSnack={10}>
                <div className='recruiter-app'>
                    <Routes>
                        <Route path={authRoutes.Login} element={<Login />} />
                        <Route path={authRoutes.SignUp} element={<SignUpPage />} />
                        <Route path={authRoutes.PasswordRecovery} element={<PasswordRecoveryPage />} />

                        <Route path={settingsRoutes.Profile} element={<Profile />} />
                        <Route path={settingsRoutes.ProfileEdit} element={<Profile />} />

                        <Route path={settingsRoutes.Settings} element={<Settings />} />
                        <Route path={settingsRoutes.ChangePassword} element={<PasswordChangePage />} />
                        <Route path={settingsRoutes.ChangeLogin} element={<ChangeLoginPage />} />
                    </Routes>
                    <Loader showLoader={loading === Loading.App} />
                    <SnackbarManager />
                </div>
            </SnackbarProvider>
        </HelmetProvider>
    );
};
